export default {
  LandingPage: {
    intro_sub:
      'Dê uma segunda vida aos resíduos de embalagens e contribua para proteger o ambiente.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Junte-se a nós na redução de resíduos',
    sequence1_2:
      'recriando a embalagem da sua produtos em peças úteis e contribuindo para um ambiente sustentável. Desça na página para o primeiro passo',
    sequence2_1: 'Apresentamos Samsung Upcycle-Packaging',
    sequence2_2:
      'Uma caixa de produtos especialmente desenhada para ser transformada contribuindo para o meio-ambiente. Construa várias peças decorativas para a sua casa',
    sequence3_1: 'Siga a linha de pontos impressa na embalagem',
    sequence3_2:
      'ACorte a caixa conforme as instruções e monte para criar peças fantásticas',
    sequence4_1: 'Selecione o objeto que deseja construir',
    sequence4_2:
      'Desça na página e selecione o modelo da caixa da sua produtos. Encontre várias opções de desenho possíveis para si. Comece a criação do objeto que escolheu',
    selectBox: 'Escolha sua produtos',
    moreActivity:
      'Obtenha mais informações sobre atividades sustentáveis na Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink: 'https://www.samsung.com/pt/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/pt/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/pt/sustainability/overview/',
    footer: 'Copyright© 2019-2021 SAMSUNG Todos os direitos reservados.',
    // <br/>
    // Este website visualiza-se melhor utilizando o Internet Explorer 11, Chrome, Safari e browsers mais recentes.`
  },
  ProductPage: {
    selectDesign: 'Escolha o design ',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Console de TV',
    StorageBox: 'Caixa de armazenamento',
    MagazineRack: 'Suporte para revistas',
    CatHouse: 'Abrigo de gato',
    CatTunnel: 'Túnel do gato',
    BookShelf: 'Estante de livros',
    DeskShelf: 'Prateleira',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Artigos de papelaria',
    CoinBank: 'Cofrinho de moeda',
    MobileScanner:'Suporte para scanner de smartphone',
    TabletScanner:'Suporte de scanner para tablet',
    PetStairs:'Escadas para animais de estimação',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minutos',
    all:'ALL',
    in: 'polegadas',
    inOnly: 'apenas polegadas',
    allBoxSize: 'Todas as medidas de caixas',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instruções',
    prepare: 'Prepare uma caixa',
    LetsDesign: 'Vamos montar?',
    drawParts: 'Desenhe as peças na parte superior caixa',
    note1:
      'Note que a posição gráfica pode variar de acordo com o país e o tamanho',
    note2: 'Esboce o desenho inteiro primeiro para que ele caiba na caixa',
    numberSpace: 'número = espaços entre pontos',
    diagonal: 'diagonal',
    LEFT: 'Esquerda',
    RIGHT: 'Direita',
    TOP: 'Topo',
    TOP1: 'Topo 1',
    TOP2: 'Topo 2',
    BACK: 'Verso',
    MIDDLE: 'Meio',
    MIDDLE2: 'Meio 2',
    BOTTOM: 'Inferior',
    FRONT: 'Frente',
    SIDE: 'Lado',
    secondSIDE: 'Segunda face',
    secondSIDE1: 'Segunda face 1',
    secondSIDE2: 'Segunda face 2',
    LEG: 'PERNA', //update
    JOINT: 'CONEXÃO', //update
    FACE: 'ROSTO', //update
    DRAWERBOTTOM: 'GAVETA INFERIOR', //update
    DRAWERSIDE: 'GAVETA LATERAL', //update
    NOSE: 'NARIZ', //update
    HANDLE: 'ALÇA', //update
    BOTTOMSIDE: 'LADO INFERIOR', //update
    TOPSIDE: 'LADO SUPERIOR', //update
    WING: 'ASA', //update
    cutAndAssemble: 'Vamos cortar e montar',
    beCareful: 'Cuidado para não se machucar com o estilete',
    cutOutParts: 'Cortar as peças',
    assemble: 'Montar',
    Assemblyguide: 'Guia de montagem', //update
    fold: 'Exemplo dobrável',
    foldGuide: 'Use a borda dos móveis ao dobrar o papelão',
    foldGuideDezeen:
      'Pressione a linha pontilhada no papelão com ferramentas de vinco algumas vezes para ajudar o papelão a dobrar', //update
    glue: 'Aplicar cola ou fita adesiva uniformemente na superfície', //update
    cable: 'Use abraçadeiras ou cordas para conectar', //update
    done: 'Pronto!',
    goBack: 'Voltar ao menu principal',
  },
  CautionPage: {
    CAUTION: 'CUIDADOS',
    needItem: 'Você precisará desses itens',
    children: 'As crianças devem participar na presença de adultos',
    mat:
      'Coloque uma proteçao no chão para evitar arranhões durante a montagem',
    doNotPutHeavyThing:
      'Não pise, nem sente sobre esses móveis e nem tente colocar coisas pesadas sobre eles',
    doNotThrow: 'Não chute e nem atire os movéis em pessoas ou animais',
    stayAwayFlame: 'Mantenha distância do fogo',
    stayAwayWater: 'Mantenha distância de água ou umidade',
    mayDamaged: '* A caixa da TV pode ser danificada durante o envio',
    companyDoestResponsible:
      '* A empresa não tem nenhuma responsabilidade por avarias ou ferimentos durante a montagem',
    cannotBeReturned:'',
    understand: 'Ok entendi',
  },
  PrivacyPolicy: {
    title: 'Política de Privacidade',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Estamos intensificando nosso compromisso com a sustentabilidade com nossas novas embalagens ecológicas.',
      text2:
        'Utilizamos menos papel e tinta para embalagens de TV, que podem ser transformados em utensílios domésticos.',
      text2_special:'',
      text3: 'Selecione os botões abaixo para descobrir mais.',
    },
    greenIn: {
      title: 'Going Green no pacote de TV',
      subtitle1: 'Informações do produto sem tinta',
      subtitle2: 'Pacote Ecológico de reutilização criativa',
      desc: 'Pesquise o nome do modelo para obter mais informações',
      descM: '*Take a photo of the TV model number',
      guide: 'nome do modelo',
      button: 'Take Photo',
      button2: 'Vá fazer itens',
    },
    search: {
      guide: 'Search..',
      noResult: 'Sem resultado',
      more: 'Mais informações',
    },
  },
  searchCountrySelect: 'Selecione um país para pesquisar'
};
